import * as VueEditor from './components/vue-editor';

export * from './components/vue-editor';

const VueEditorLibrary = {
  install(app) {
    // register all exports as vue components
    const components = Object.keys(VueEditor) || [];
    components.forEach((key) => {
      if (key !== 'helper' && key !== 'EditableMixin') {
        const component = VueEditor[key];
        app.component(component.name, component);
      }
    });
  }
};

export default VueEditorLibrary;

// in case vue is loaded already in window
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueEditorLibrary);
}
